import script from "./partyUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./partyUpload.vue?vue&type=script&setup=true&lang=ts"

import "./partyUpload.vue?vue&type=style&index=0&id=42b84fa0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42b84fa0"]])

export default __exports__